import { useEffect } from "react";
import { clearUserAuthCookies } from '../utils/authCookies';

const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
];

const AppLogout = ({ children }) => {
    let timer;
    const handleLogoutTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            logoutAction();
        }, 24 * 60 * 60 * 1000);
    };

    const resetTimer = () => {
        if (timer) clearTimeout(timer);
    };


    useEffect(() => {
        const handlers = {};

        Object.values(events).forEach((item) => {
            const handler = () => {
                resetTimer();
                handleLogoutTimer();
            };
            handlers[item] = handler;
            window.addEventListener(item, handler);
        });

        // Cleanup function to remove event listeners
        return () => {
            Object.values(events).forEach((item) => {
                if (handlers[item]) {
                    window.removeEventListener(item, handlers[item]);
                }
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty deps intentional - setup once on mount

    const logoutAction = () => {
        clearUserAuthCookies();
        window.location.replace("/");
    };

    return children;
};

export default AppLogout;